import { parseIconType } from '../../utils/normalizers/parseIconByNotificationType'
import * as constants from '../constants'

const initialState = {
  chargePoints: { chargePointList: [] },
  allOriginChargePoints: { chargePointList: [] },
  plugShareOriginChargePoints: { chargePointList: [] },
}

export function chargePointsReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_CHARGEPOINTS:
      return {
        ...state,
        chargePoints: action.chargePoints,
      }

    case constants.SET_ALL_ORIGIN_CHARGEPOINTS:
      return {
        ...state,
        allOriginChargePoints: action.chargePoints,
      }

    case constants.SET_PLUG_SHARE_CHARGEPOINTS:
      return {
        ...state,
        plugShareOriginChargePoints: action.chargePoints,
      }

    case constants.SET_CHARGEPOINT_CONNECTOR:
      return {
        ...state,
        chargePoints: {
          chargePointList: state.chargePoints.chargePointList.map((chargePoint) => {
            if (chargePoint.chargeBoxId === action.chargeBoxId) {
              return {
                ...chargePoint,
                connectors: chargePoint.connectors.map((connector) => {
                  if (connector.connectorId === action.connectorId) {
                    return {
                      ...connector,
                      lastStatus: {
                        ...connector.lasStatus,
                        status: action.connector.status,
                      },
                    }
                  } else return connector
                }),
              }
            } else return chargePoint
          }),
        },
      }

    case constants.SET_CONNECTOR_TYPE:
      return {
        ...state,
        chargePoints: {
          chargePointList: state.chargePoints.chargePointList.map((chargePoint) => {
            if (chargePoint.chargeBoxPk === parseInt(action.chargeBoxPk)) {
              return {
                ...chargePoint,
                connectors: chargePoint.connectors.map((connector) => {
                  if (connector.connectorId === parseInt(action.connectorId)) {
                    return {
                      ...connector,
                      connectorType: action.connectorType,
                    }
                  } else return connector
                }),
              }
            } else return chargePoint
          }),
        },
      }

    case constants.SET_CHARGE_POINT:
      return {
        ...state,
        chargePoints: {
          chargePointList: state.chargePoints.chargePointList.map((chargePoint) => {
            if (chargePoint.chargeBoxPk === parseInt(action.chargeBoxPk)) {
              return action.data
            } else return chargePoint
          }),
        },
        allOriginChargePoints: {
          chargePointList: state.allOriginChargePoints.chargePointList.map((chargePoint) => {
            if (chargePoint.chargeBoxPk === parseInt(action.chargeBoxPk)) {
              return action.data
            } else return chargePoint
          }),
        },
        plugShareOriginChargePoints: {
          chargePointList: state.plugShareOriginChargePoints.chargePointList.map((chargePoint) => {
            if (chargePoint.chargeBoxPk === parseInt(action.chargeBoxPk)) {
              return action.data
            } else return chargePoint
          }),
        },
      }
    default:
      return state
  }
}
